export interface RecentFileEntry {
  fileName: string;
  lastOpenedAt: string;
}

const STORAGE_KEY = 'timeline_recent_files_v1';
const MAX_ENTRIES = 20;

export class RecentFilesService {
  list(): RecentFileEntry[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const entries: RecentFileEntry[] = JSON.parse(raw);
      return entries.sort(
        (a, b) => new Date(b.lastOpenedAt).getTime() - new Date(a.lastOpenedAt).getTime(),
      );
    } catch {
      return [];
    }
  }

  addOrUpdate(entry: RecentFileEntry): void {
    const entries = this.list().filter((e) => e.fileName !== entry.fileName);
    entries.unshift(entry);
    if (entries.length > MAX_ENTRIES) {
      entries.length = MAX_ENTRIES;
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  }

  remove(fileName: string): void {
    const entries = this.list().filter((e) => e.fileName !== fileName);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  }

  clear(): void {
    localStorage.removeItem(STORAGE_KEY);
  }
}
